import { faPlusSquare } from "@fortawesome/free-regular-svg-icons";
import SubTabNoData from "../../../../_shoru_shared_library/components/console_page/sub_tab/SubTabNoData";
import SubTabSection from "../../../../_shoru_shared_library/components/console_page/sub_tab/SubTabSection";
import './History.css';
import { Undo } from "@mui/icons-material";


export function History(props) {

  const history = structuredClone(props.additional.history).reverse();
  const setHistory = props.additional.setHistory;
  const setClashBotData = props.additional.setClashBotData;
  const setRegister = props.additional.setRegister;

  const handleUndo = () => {
    const toRestore = props.additional.history.pop();
    setClashBotData(toRestore.clashBotData);
    setRegister(toRestore.register);
    setHistory(props.additional.history);
  }

  if(history.length === 0) {
    return (
      <SubTabNoData 
        icon={faPlusSquare} 
        title='No Casting History' 
        description="As you make casting decisions, they will appear here"
      />
    )
  }

  return (
    <div className='history-tab'>
      <div className='history-undo-button'>
        <div onClick={handleUndo}>
          <p style={{fontWeight: '600', fontSize: '12px'}}>Undo Last</p>
          <Undo />
        </div>
      </div>
      {
        history.map((h) => 
          <HistoryStatement h={h} />
        )
      }
    </div>
  )

}


function HistoryStatement({h}) {

  return (
    <div className='history-statement'>
      <div className='history-time'>{h.time}</div>
      <div>
        <h3>{h.titleStatement}</h3>
        {
          h.smallStatements.map((s, i) => 
            <p key={`${s}-${i}`}>{s}</p>
          )
        }
      </div>
    </div>
  )

}